import PrivacySettings from 'components/pages/PrivacySettings/PrivacySettings';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('account', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(PrivacySettings, {
  requiresAuthentication: true,
  fullPageWidth: false,
  metaData: {
    title: 'Privacy Settings',
    description: 'Manage your privacy settings',
  },
});
